export const divideArray = <T>(array: T[], predicate: (item: T) => boolean): [T[], T[]] =>
  array.reduce(
    ([pass, fail], elem) => (predicate(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]]),
    [[], []]
  );
